import { useTranslation } from "react-i18next";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Shell } from "@/components/Shell";

/**
 * A sign-in matching no persoon gets a page and no session, never an application that happens to
 * be empty. It says the address may not be the one JBNL has, never which address that is
 * (docs/adr/0018-identity-linking.md).
 */
export function AccountUnknown() {
  const { t } = useTranslation(["account", "common"]);
  const mailbox = t("common:mailbox");
  const aanmeldsite = t("common:aanmeldsite");

  return (
    <Shell>
      <Card>
        <CardHeader>
          <CardTitle>{t("unknown.title")}</CardTitle>
          <CardDescription>{t("unknown.description")}</CardDescription>
        </CardHeader>
        <CardContent className="space-y-3 text-sm">
          <p>
            {t("unknown.collegaBefore")}
            <a className="jb-link" href={`mailto:${mailbox}`}>
              {mailbox}
            </a>
            {t("unknown.collegaAfter")}
          </p>
          <p className="text-muted-foreground">
            {t("unknown.aanmeldsiteBefore")}
            <a className="jb-link" href={`https://${aanmeldsite}`}>
              {aanmeldsite}
            </a>
            {t("unknown.aanmeldsiteAfter")}
          </p>
          <p>
            <a className="jb-link" href="/">
              {t("common:actions.backToStart")}
            </a>
          </p>
        </CardContent>
      </Card>
    </Shell>
  );
}
